import { render } from "./LinkReferido.vue?vue&type=template&id=00bea8b6&scoped=true"
import script from "./LinkReferido.vue?vue&type=script&lang=js"
export * from "./LinkReferido.vue?vue&type=script&lang=js"

import "./LinkReferido.vue?vue&type=style&index=0&id=00bea8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bea8b6"]])

export default __exports__